import React from "react";
import { motion } from "framer-motion";
import key_3 from "../assets/1.png";
import key_4 from "../assets/2.png";
import icon_1 from "../assets/icon/1.png";
import icon_2 from "../assets/icon/2.png";
import icon_3 from "../assets/icon/3.png";
import Header from "./Header";
import { Helmet } from "react-helmet-async";
import about1 from "../assets/About Us/Top-image_2.png";
import about2 from "../assets/About Us/Bottom-image_V1.png";
import RotatingCircle from "../components/RotatingCircle ";
import { MdDescription } from "react-icons/md";

const textVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const imageVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1.2 } },
};

const headingVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const paragraphVariants = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const About = () => {
  return (
    <div>
      <Header />
      <Helmet>
        <title>About Fusion Spin | Slot Game Services & Outsourcing</title>
        <meta name="description" content="Learn more about Fusion Spin, a leading provider of slot game services and outsourcing solutions. Explore our commitment to innovation in slot game development." />
        <meta name="keywords" content="About Fusion Spin, casino slot software solutions, land slot services, slot game outsourcing, land-based casino games, custom slot machines, casino game development, slot game services" />
      </Helmet>

      <div className="container mx-auto px-4 py-8 flex flex-col lg:flex-row items-center lg:justify-around gap-8">
        <motion.img
          src={about1}
          alt="Slot Machine Cabinet"
          title="Slot Machine Cabinet"
          className="w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl h-auto"
          initial="hidden"
          animate="visible"
          variants={imageVariants}
        />

        <div className="lg:w-1/2 w-full">
          <div className="">
            <motion.h2
              className="text-3xl md:text-4xl lg:text-5xl text-center lg:text-start font-bold mb-4"
              initial="hidden"
              animate="visible"
              variants={headingVariants}
            >
              Who <span className="text-[#FF5300]">Are We?</span>
            </motion.h2>

            <motion.p
              className="md:text-[18px] text-[14px] lg:text-base text-gray-600 text-justify poppins-font2 leading-relaxed mb-4"
              initial="hidden"
              animate="visible"
              variants={paragraphVariants}
            >
              Welcome to Fusion Spin—your gateway to the future of land-based slot gaming! At Fusion Spin, we specialize in delivering cutting-edge casino slot development and land slot services, combining robust hardware with advanced jackpot systems to ensure an unparalleled gaming experience. Whether you’re a casino operator or a gaming enthusiast, our Land Slots Platform is designed to offer efficiency, reliability, and limitless entertainment.
              <br /><br />
              We are driven by a passion for innovation and a commitment to creating high-quality, customized solutions. Our mission is to empower gaming businesses with advanced tools and systems that simplify operations while enhancing player satisfaction.
            </motion.p>

            <motion.h2
              className="text-3xl md:text-4xl font-bold mb-4 text-center lg:text-start"
              initial="hidden"
              animate="visible"
              variants={headingVariants}
            >
              Our Vision
            </motion.h2>

            <motion.p
              className="md:text-[18px] text-[14px] lg:text-base text-gray-600 text-justify poppins-font2 leading-relaxed mb-4"
              initial="hidden"
              animate="visible"
              variants={paragraphVariants}
            >
              We are committed to revolutionizing the slot gaming industry through innovation and customer-centric solutions. By integrating state-of-the-art technologies and customizable features, we aim to be the go-to partner for casino game outsourcing and slot game development. Our team of experienced professionals brings a deep understanding of the industry, ensuring that our solutions are not just advanced but also practical and user-friendly.
            </motion.p>

            <motion.h2
              className="text-3xl md:text-4xl font-bold mb-4 text-center lg:text-start"
              initial="hidden"
              animate="visible"
              variants={headingVariants}
            >
              Why Choose Us
            </motion.h2>

            <motion.p
              className="md:text-[18px] text-[14px] lg:text-base text-gray-600 text-justify poppins-font2 leading-relaxed"
              initial="hidden"
              animate="visible"
              variants={paragraphVariants}
            >
              We believe in delivering smart, effective solutions tailored to meet the needs of modern casinos. Our platform is built with the operator in mind—offering comprehensive tools to manage slot games, analyze performance, and enhance player engagement.
            </motion.p>
          </div>
        </div>
      </div>

      <div className="bg-[#eeeeee] px-4 py-16 md:px-8">
        <div className="container mx-auto flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2 w-full space-y-8">
            <motion.h2
              className="text-2xl md:text-3xl lg:text-4xl text-center lg:text-left font-bold leading-snug"
              initial="hidden"
              animate="visible"
              variants={headingVariants}
            >
              We are here for you to provide smart and effective solutions
            </motion.h2>
            <hr className="w-14 bg-black h-[2px] border-none shadow-lg mb-7 mx-auto lg:mx-0" />

            <div className="space-y-12">
              {[
                { icon: icon_1 , title: "Unmatched Customization", description: "Our system supports individual jackpot setups for each slot machine, featuring Mini, Minor, Major, and Grand levels—fully customizable to meet your specific requirements. Operators can customize jackpot thresholds to align with player preferences, boosting both engagement and revenue." },
                { icon: icon_2, title: "Data-Driven Insights", description: "Utilize real-time data insights to monitor performance and enhance gameplay. The platform seamlessly integrates with industry-standard analytics tools, enabling casino operators to make data-backed decisions with confidence. Data visualization features offer easy interpretation of performance metrics, making it simple to fine-tune strategies." },
                { icon: icon_3, title: "Innovation at Its Core", description: `We consistently push the boundaries of innovation, creating immersive gaming experiences that keep players engaged while maximizing operational efficiency.`, decscription2: "Partner with Fusion Spin today and elevate your slot gaming business to new heights!" },
              ].map((item, index) => (
                <div key={index} className="flex flex-col md:flex-row items-center md:gap-6 gap-4">
                  <motion.img
                    src={item.icon}
                    alt="Icon"
                    className="h-20 w-20"
                    initial="hidden"
                    animate="visible"
                    variants={headingVariants}
                  />
                  <div>
                    <motion.h3 className="text-lg md:text-xl font-bold text-center md:text-start">{item.title}</motion.h3>
                    <motion.p className="md:text-[18px] text-[14px] lg:text-base text-gray-600 text-justify poppins-font2 leading-relaxed pt-4"
                      initial="hidden" animate="visible" variants={paragraphVariants}>
                      {index === 2 ? (<>{item.description}<br />{item.decscription2}</>) : item.description}
                    </motion.p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <motion.img
            src={about2}
            alt="Slot Game Theme"
            title="Slot Game Theme"
            className="w-full max-w-sm sm:max-w-md lg:max-w-[50%] mx-auto"
            initial="hidden"
            animate="visible"
            variants={imageVariants}
          />
        </div>
      </div>
    </div>
  );
};

export default About;
